// extracted by mini-css-extract-plugin
module.exports = {"list":"page_list__OS4Ey","pastEventsTitle":"page_pastEventsTitle__iutWh","pastEventsEmphasized":"page_pastEventsEmphasized__42ErK","noEvents":"page_noEvents__ZCy1F"};